import rangy from 'rangy';
require('rangy/lib/rangy-textrange');
rangy.init();

export const isExistingElementOrTextNode = (node: Node) =>
  node !== null &&
  (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE);

export default rangy;
